<template>
    <div class="w-screen h-screen p-safe flex">
        <div class="m-auto">
            <img
                src="/images/logo-light.svg"
                class="h-24 animate-scale-pulse dark:hidden"
            >

            <img
                src="/images/logo-dark.svg"
                class="h-24 animate-scale-pulse hidden dark:block"
            >
        </div>
    </div>
</template>

<script setup>
    defineOptions({
        name: 'SplashScreen',
    });
</script>
